
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getRemoveTeammembershipDtoFormGroup() {
return new FormGroup({
    teamId: new FormControl<number | undefined>(undefined, [Validators.required]),
    dateFrom: new FormControl<string | undefined>('', [Validators.required]),
    dateTo: new FormControl<string | undefined>('', [Validators.required]),
})
;
}
      